import React, { FC } from 'react';
import { ProgressBar } from 'src/shared/globals';
import CheckCircle from 'src/shared/icons/check-circle.svg';
import ExclamationCircle from 'src/shared/icons/exclamation-circle-solid.svg';
import styled from 'styled-components';
import { Spinner } from '../spinner';

export type UploadStatus = 'PENDING' | 'UPLOADING' | 'PROCESSING' | 'COMPLETED' | 'ERROR' | 'ERROR_LARGEFILE';

const UploadFileRow = styled.div`
    margin-bottom: 20px;
`;

const UploadFileHeader = styled.div`
    display: flex;
    justify-content: space-between;

    ${Spinner} {
        width: 28px;
        height: 24px;
        margin-right: 10px;
    `;

const Label = styled.span`
    overflow: hidden;
    margin-right: 30px;
    flex: 1;
`;

const StyledCheck = styled(CheckCircle)`
    fill: #228b22;
    width: 24px;
    height: 24px;
    margin-right: 10px;
`;
const StyledError = styled(ExclamationCircle)`
    fill: #ff0000;
    width: 24px;
    height: 24px;
    margin-right: 10px;
`;

const UploadProgressRow: FC<{ label: string; progress: number; status: UploadStatus }> = ({ label, progress, status }) => (
    <UploadFileRow>
        <UploadFileHeader>
            <Label>{label}</Label>

            {status !== 'COMPLETED' && status !== 'ERROR' && <Spinner />}
            {status === 'ERROR' && <StyledError />}
            {status === 'COMPLETED' && <StyledCheck />}
        </UploadFileHeader>
        <ProgressBar progress={progress} />
    </UploadFileRow>
);

export default UploadProgressRow;
